import React from 'react'
import {
  Menu,
  TextField,
  MenuItem,
  Button,
  Box,
  Typography,
} from '@mui/material'
import { InvoiceStatus } from '../../types/payment'

interface InvoiceFiltersProps {
  statusFilter: InvoiceStatus | ''
  startDate: string
  endDate: string
  onStatusChange: (status: InvoiceStatus | '') => void
  onStartDateChange: (date: string) => void
  onEndDateChange: (date: string) => void
  onClear: () => void
  onApply: () => void
  anchorEl: HTMLElement | null
  onClose: () => void
}

const InvoiceFilters: React.FC<InvoiceFiltersProps> = ({
  statusFilter,
  startDate,
  endDate,
  onStatusChange,
  onStartDateChange,
  onEndDateChange,
  onClear,
  onApply,
  anchorEl,
  onClose,
}) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: { width: 320, p: 2, borderRadius: 2 }
        }
      }}
    >
      <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 2 }}>
        Filter Invoices
      </Typography>
      
      <TextField
        fullWidth
        select
        label="Payment Status"
        value={statusFilter}
        onChange={(e) => onStatusChange(e.target.value as InvoiceStatus | '')}
        sx={{ mb: 2 }}
        size="small"
      >
        <MenuItem value="">All Statuses</MenuItem>
        <MenuItem value="draft">Draft</MenuItem>
        <MenuItem value="sent">Sent</MenuItem>
        <MenuItem value="partially_paid">Partially Paid</MenuItem>
        <MenuItem value="paid">Paid</MenuItem>
        <MenuItem value="overdue">Overdue</MenuItem>
        <MenuItem value="cancelled">Cancelled</MenuItem>
      </TextField>

      <TextField
        fullWidth
        type="date"
        label="Start Date"
        value={startDate}
        onChange={(e) => onStartDateChange(e.target.value)}
        InputLabelProps={{ shrink: true }}
        sx={{ mb: 2 }}
        size="small"
      />

      <TextField
        fullWidth
        type="date"
        label="End Date"
        value={endDate}
        onChange={(e) => onEndDateChange(e.target.value)}
        InputLabelProps={{ shrink: true }}
        sx={{ mb: 2 }}
        size="small"
      />

      <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
        <Button
          size="small"
          onClick={onClear}
          sx={{ textTransform: 'none' }}
        >
          Clear
        </Button>
        <Button
          size="small"
          variant="contained"
          onClick={onApply}
          sx={{ textTransform: 'none' }}
        >
          Apply
        </Button>
      </Box>
    </Menu>
  )
}

export default InvoiceFilters
